import { PaymentWindowRequestCreditCardSpace } from 'src/types/api'

const Payment = ({
  paymentData,
}: {
  paymentData: PaymentWindowRequestCreditCardSpace.BillgateRequest
}) => {
  //쿠폰사 교체로 인해 ITEM_CODE 맨앞 구분문자 추가됨.
  //결제페이지 요청시에는 구분문자 버리고 뒷숫자들만 사용.
  paymentData = {
    ...paymentData,
    ITEM_CODE:
      paymentData.ITEM_CODE?.length > 10 ? paymentData.ITEM_CODE.slice(-10) : paymentData.ITEM_CODE,
  }

  return (
    <form
      id="payment"
      name="payment"
      encType="euc-kr"
      acceptCharset="EUC-KR"
      method={'post'}
      style={{ visibility: 'hidden', height: '0', position: 'absolute' }}
    >
      {Object.entries(paymentData).map(([name, value]) => (
        <input
          style={{ visibility: 'hidden', height: '0' }}
          readOnly
          key={name}
          name={name}
          value={value || ''}
        />
      ))}
    </form>
  )
}

export default Payment
